// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardPOByStatusTable_wrapper__eibkO","title":"DashboardPOByStatusTable_title__tQgCt"};